import { render, staticRenderFns } from "./NewEditApps.vue?vue&type=template&id=24c48aba&"
import script from "../../models/usen-manage/new-edit-apps.ts?vue&type=script&lang=ts&"
export * from "../../models/usen-manage/new-edit-apps.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports